export const BETKWIFF_ZENDESK = 'https://static.zdassets.com/ekr/snippet.js?key=1c597188-2435-40a8-b78c-8896d487b2a6';
export const KWIFF_ZENDESK = 'https://static.zdassets.com/ekr/snippet.js?key=74b37d6b-b125-45af-8378-dcafb7d92abb';
export const TEST_SANDBOX_ZENDESK = 'https://static.zdassets.com/ekr/snippet.js?key=f35b597f-371c-4d93-8a0e-813d454db27e';

export const KWIFF_ZENDESK_FAQ_URL = 'https://kwiff.zendesk.com/';
export const BETKWIFF_ZENDESK_FAQ_URL = 'https://betkwiff.zendesk.com/';

export const initialClassicWebWidgetSettings = {
  webWidget: {
    launcher: {
      label: {
        'en-US': 'Support',
      },
      mobile: {
        labelVisible: true,
        label: {
          'en-US': 'Support',
        },
      },
    },
    helpCenter: {
      title: {
        'en-US': 'Support',
      },
      suppress: true,
    },
    offset: {
      horizontal: '0',
      vertical: '0',
      mobile: {
        horizontal: '0',
        vertical: '56px',
      },
    },
    color: {
      theme: '#8225FA',
    },
    navigation: {
      popoutButton: {
        enabled: false,
      },
    },
    chat: {
      hideWhenOffline: true,
    },
  },
};
